module.exports = __webpack_public_path__ + "img/smb-id-tag-black.256.39736e87.png";